import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function BrochureIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M7 0V7H2V24H17V6.74609L11.6388 2H20V15H18.5205V17H22V0H7ZM15 22H4V9H15V22ZM9 7V2.33594L14.2696 7H9ZM7.5 13C7.5 11.8954 8.39545 11 9.5 11C10.6046 11 11.5 11.8954 11.5 13C11.5 14.1045 10.6046 15 9.5 15C8.39545 15 7.5 14.1045 7.5 13ZM6 17H13V19H6V17Z",
    fill: "currentColor"
  }));
}